<template>
  <div id="aggregateManager">
    <div class="allMenuHead">
      <div :class="step ? 'active' : ''" @click="toUrl('aggregateList', 1)" class="d_i headTab p_r">聚合页管理<div class="p_a"></div></div>
    </div>
    <div class="allHeaderRouter">
      <transition name="fadeLeft">
        <router-view></router-view>
      </transition>
    </div>
  </div>
</template>

<script>
let Time
  export default {
    name: 'aggregateManager',
    data () {
      return {
        step: true,
        isSystemAdmin: window.sessionStorage.getItem('isSystemAdmin'),
        appowner: JSON.parse(window.sessionStorage.getItem('nowApp'))
      }
    },
    created () {
      Time = setInterval(p => {
        if (window.location.href.indexOf('aggregateList') >= 0) {
          this.step = true
        } else {
          this.step = false
        }
      }, 100)
    },
    destroyed () {
      clearInterval(Time)
    },
    methods: {
      toUrl (url, num) {
        if (num === 1) {
          this.step = true
        } else {
          this.step = false
        }
        this.$router.push({
          name: url
        })
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/pages/aggregateManager/aggregateManager.vue